import { __, __cases } from "@libs/utilities"
import { useDataStore } from "@/modules/pe-basic-module/data/store"
import { Tag } from "@blueprintjs/core"
import { IPEFestSchool, IProject, ITrack, SPECIAL_SORT_TYPE } from "../../data/interfaces"
import getSchoolProjects from "../../data/utils/getSchoolProjects"
import getSchoolUniqTutors from "../../data/utils/getSchoolUniqTutors"
import getSchoolUniqUsers from "../../data/utils/getSchoolUniqUsers"

/* Protopia Ecosystem component */
export interface ISpecialTitleRowProps {
    sortField: SPECIAL_SORT_TYPE
    prev: IProject
    current: IProject
    members: IProject[] 
}
 
const SpecialTitleRow = (props: ISpecialTitleRowProps): JSX.Element => {
    switch(props.sortField) {
        case SPECIAL_SORT_TYPE.SCHOOLS_SORT: 
            const is: boolean = props.prev?.fmru_school[0]?.id !== props.current?.fmru_school[0]?.id
            if(is) { 
                let uniqUsers = getSchoolUniqUsers( props.current?.fmru_school[0]?.id,  props.members )
                let uniqTutors = getSchoolUniqTutors( props.current?.fmru_school[0]?.id,  props.members ) 
                let projects = getSchoolProjects( props.current?.fmru_school[0]?.id,  props.members )
                return <>
                    <tr className='bg-secondary-light  border-top border-secondary border-2'>
                        <td colSpan={ 40 }>
                            <div className="lead" style={{height: 5}} /> 
                        </td>
                    </tr> 
                    <tr className='bg-secondary-light '>  
                        <td colSpan={ 40 }>
                            <div className=" py-3">
                                <span className="small text-secondary mr-2">
                                    {__("Education organization")}:
                                </span> 
                                <SchoolTitle school={ props.current?.fmru_school[0] } />
                                <Tag className="mr-1">
                                    { projects.length } { __cases( projects.length, "projects", ) }
                                </Tag>
                                <Tag className="mr-1">
                                    { uniqUsers.length } { __cases( uniqUsers.length, "uniq_users", ) } 
                                </Tag>
                                <Tag className="mr-1">
                                    { uniqTutors.length } { __cases( uniqTutors.length, "uniq_tutors", ) } 
                                </Tag>
                            </div> 
                        </td>
                    </tr>
                </>
            }
            else{  
                
                // console.log( props.current )
                // props.setUniqUsers( [
                //     ...props.uniqUsers,
                //     ...u
                // ] as IUser[] ) 
                return<></>
            }
        case SPECIAL_SORT_TYPE.TRACK_SORT:
            const is2: boolean = props.prev?.track?.id !== props.current?.track?.id

            return is2 
            ?
            <>
                <tr className='bg-secondary-light  border-top border-secondary border-2'>
                    <td colSpan={ 40 }>
                        <div className="lead" style={{height: 5}} /> 
                    </td>
                </tr>
                <tr className='bg-secondary-light '>
                    <td colSpan={ 40 }>
                        <div className="py-3">
                            <span className="small text-secondary mr-2">
                               {__("Track")}:  
                            </span>
                            <TrackTitle track={ props.current?.track } />
                        </div> 
                    </td>
                </tr>
            </>
            :
            <></>
        default:
            return <></>

    }
}
export default SpecialTitleRow

interface ISchoolTitleProps {
    school: IPEFestSchool
}
const SchoolTitle = ({school}:ISchoolTitleProps):JSX.Element => {
    const schools : IPEFestSchool[] = useDataStore((state:any) => state.PEFestSchool)
    return <>
        <span className="lead">
            { school?.title }
        </span>
        <span className="mx-2 small text-secondary ">
            {__("School_guardians")} :
        </span>
        <span className=" title text-secondary">
            <span className="mx-2">
                { schools.find(t => t.id === school?.id)?.guardian?.display_name } 
            </span>
            <span className="mx-2">
                { schools.find(t => t.id === school?.id)?.guardian2?.display_name } 
            </span>
             
        </span>
    </>
}

interface ITrackTitleProps {
    track:ITrack
}
const TrackTitle = ({track}:ITrackTitleProps):JSX.Element => {
    const tracks : ITrack[] = useDataStore((state:any) => state.PEFestTrack)
    return <>
        <span className="lead">
            { track?.title }
        </span>
        <span className="mx-2 small text-secondary ">
            {__("Moderators")} :
        </span>
        <span className=" title text-secondary">
            <span className="mx-2">
                { tracks.find(t => t.id === track?.id)?.moderator?.display_name }
            </span>
            <span className="mx-2">
                { tracks.find(t => t.id === track?.id)?.moderator2?.display_name }
            </span>
        </span>
    </>
}